import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAdminAuth, formatApiError } from "../auth";

const AdminLogin = () => {
  const { user, login } = useAdminAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(form.email, form.password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err) || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vd-page flex items-center justify-center" style={{ minHeight: "100vh", background: "var(--bg-secondary)" }} data-testid="admin-login-page">
      <form onSubmit={onSubmit} className="vd-card p-8 w-full max-w-md" data-testid="admin-login-form">
        <h1 className="mb-1" style={{ fontSize: 28 }}>ValueDrive Admin</h1>
        <p className="vd-muted text-sm mb-6">Sign in to manage products, stock & orders.</p>
        <label className="vd-muted text-xs uppercase tracking-wider">Email</label>
        <input
          type="email"
          className="vd-input mt-1 mb-4"
          value={form.email}
          onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          required
          autoFocus
          data-testid="admin-login-email"
        />
        <label className="vd-muted text-xs uppercase tracking-wider">Password</label>
        <input
          type="password"
          className="vd-input mt-1 mb-4"
          value={form.password}
          onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
          required
          data-testid="admin-login-password"
        />
        {error && <p className="text-sm mb-3" style={{ color: "var(--primary-red)" }} data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} className="vd-btn-primary w-full justify-center" data-testid="admin-login-submit">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
